import { render, staticRenderFns } from "./mainBannerArgos.vue?vue&type=template&id=91c665f6"
import script from "./mainBannerArgos.vue?vue&type=script&lang=js"
export * from "./mainBannerArgos.vue?vue&type=script&lang=js"
import style0 from "./mainBannerArgos.vue?vue&type=style&index=0&id=91c665f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports